export const css = {
    root: '_31uElxbK',
    small: 'mulUmhjH',
    divider: '_3jYrR6Tc',
    ' _key': 'ascm-theme/dojo/two-column-layout'
};
export default css;
